export function hasClass(el, className) {
  if (el) {
    return el.classList.contains(className);
  }
  return false;
}

export function addClass(el, className) {
  if (el && el.classList) {
    el.classList.add(className);
  }
}

export function removeClass(el, className) {
  if (el && el.classList) {
    el.classList.remove(className);
  }
}
